// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__11v9y","title":"ClientInsurance_title__3yJLD","itemText":"ClientInsurance_itemText__3BaAs"};